import { Component } from "@angular/core";
import { GlobalVariables } from "../../../shared/models/cameralla-global.model";
import { Photo } from "../../../shared/models/cameralla-photo.model";
import { FormGroup, NgForm } from "@angular/forms";
import { CamerallaUser } from "../../../shared/models/cameralla-user.model";
import { FileSystemFileEntry, UploadEvent } from "ngx-file-drop";
import { Observable, of } from "rxjs";
import * as $ from "jquery";
import { ManagementComponent } from "../management";
import * as _ from "lodash";
import { CroppieOptions } from "croppie";
import { BannerPhotoComponent } from "../banner-photo/banner-photo";
import { MobileBannerPhotoComponent } from "../mobile-banner-photo/mobile-banner-photo";
import AppShareHelper from "../../../shared/utils/helper";
import { PartnerService } from "../../../shared/services/partner.service";

@Component({
  selector: "app-banner-management",
  templateUrl: "./banner-management.html",
})
export class BannerManagementComponent extends ManagementComponent {
  bannerPhoto: Photo;
  bannerPhotoMobile: Photo;
  logoPhoto: Photo;
  fileList: FileList;
  file: File;
  logofile: File;
  bannerMobileEditStatus: boolean = false;
  bannerEditStatus: boolean = false;
  bannerFileCropped;
  bannerMobileFileCropped;
  formData: FormData;
  items = [];
  categories: any[];
  formValid = true;
  photoSelected = true;
  form = new FormGroup({});
  tagMo: string[] = [];
  maxLength = 500;
  userProfile: CamerallaUser;
  configCKEditor: boolean = false;
  bannerArr = [];
  bannerMobileArr = [];
  extraParams = {};

  // Config permission for user Kampsport can edit banner
  currentPartner: any = this.onlyKampsport
    ? BannerManagementComponent.partners.KAMPSPORT
    : BannerManagementComponent.partners.EXPLORER;
  public partnerInfo: any = {};
  partnerName = this.onlyKampsport ? "Kampsport" : "Explorer";
  homeRoute = GlobalVariables.HOME_ROUTE;

  // Config partner
  public static readonly partners = {
    EXPLORER: 1,
    CANNON: 2,
    HURTIGRUTEN: 4,
    KAMPSPORT: 5,
    NAF: 6,
  };

  public getTags(tags) {
    if (!tags) {
      return "N/A";
    } else {
      if (tags.length) {
        return tags.join(", ").toUpperCase();
      }
      return "N/A";
    }
  }

  editBanner(type, banner) {
    const modalRef = this._modalService.open(BannerPhotoComponent, {
      centered: true,
      windowClass: type === "banner" ? "super" : "sm",
    });
    modalRef.componentInstance.currentPartner = this.currentPartner;
    modalRef.componentInstance.bannerUrl = banner.url;
    modalRef.componentInstance.filterMembersTags = banner.tags;
    modalRef.componentInstance.navigateUrl = banner.navigateUrl;
    modalRef.componentInstance.id = banner.id;
    modalRef.componentInstance.uploadSuccess.subscribe((res) => {
      let cloneParams = AppShareHelper.deepClone(this.partnerInfo);
      const typeName = type + "Arr";

      let index = _.findIndex(cloneParams[typeName], { id: res.id });
      if (index >= 0) {
        cloneParams[typeName][index].navigateUrl = res.navigateUrl;
        cloneParams[typeName][index].tags = res.tags;

        this.http
          .put(PartnerService.partnerAPI + this.currentPartner, cloneParams)
          .subscribe(
            (res: any) => {
              if (res.Data && res.Data) {
                this[typeName] = res.Data[typeName];
                this.partnerInfo[typeName] = cloneParams[typeName];
              }
            },
            (error) => {
              this.toastr.error(error.error.Message, "Update failed");
            }
          );
      }
    });
  }

  addPhotoBanner() {
    const modalRef = this._modalService.open(BannerPhotoComponent, {
      centered: true,
      windowClass: "super",
    });
    modalRef.componentInstance.currentPartner = this.currentPartner;
    modalRef.componentInstance.uploadSuccess.subscribe((res) => {
      this.bannerArr = res.Data.bannerArr;
      this.partnerInfo.bannerArr = res.Data.bannerArr;
    });
  }

  addMobilePhotoBanner() {
    const modalRef = this._modalService.open(MobileBannerPhotoComponent, {
      centered: true,
    });
    modalRef.componentInstance.currentPartner = this.currentPartner;
    modalRef.componentInstance.uploadSuccess.subscribe((res) => {
      this.bannerMobileArr = res.Data.bannerMobileArr;
      this.partnerInfo.bannerMobileArr = res.Data.bannerMobileArr;
    });
  }

  removePhoto(type) {
    const isConfirm = confirm(`Do you really want to remove the ${type} ?`);

    if (isConfirm) {
      this[type + "delete"] = true;
      this.partnerInfo[type] = "";
      this.updatePartnerInfo();
    }

    return "";
  }

  removeCarouselBannerPhoto(type, banner) {
    const isConfirm = confirm(
      `Do you really want to remove this photo banner ?`
    );
    const typeName = type + "Arr";

    if (isConfirm) {
      let cloneParams = AppShareHelper.deepClone(this.partnerInfo);
      cloneParams[typeName] = _.filter(this[typeName], (o) => {
        return banner.id !== o.id;
      });

      this.http
        .put(PartnerService.partnerAPI + this.currentPartner, cloneParams)
        .subscribe(
          (res: any) => {
            if (res.Data && res.Data) {
              this[typeName] = res.Data[typeName];
              this.partnerInfo[typeName] = cloneParams[typeName];
            }
          },
          (error) => {
            this.toastr.error(error.error.Message, "Update failed");
          }
        );
    }

    return "";
  }

  // Choose Partner
  choosePartner(partner) {
    switch (partner) {
      case "explorer":
        this.currentPartner = BannerManagementComponent.partners.EXPLORER;
        this.partnerName = "Explorer";
        break;
      case "canon":
        this.currentPartner = BannerManagementComponent.partners.CANNON;
        this.partnerName = "Canon";
        break;
      case "hurtigruten":
        this.currentPartner = BannerManagementComponent.partners.HURTIGRUTEN;
        this.partnerName = "Hurtigruten";
        break;
      case "kampsport":
        this.currentPartner = BannerManagementComponent.partners.KAMPSPORT;
        this.partnerName = "Kampsport";
        break;
      case "naf":
        this.currentPartner = BannerManagementComponent.partners.NAF;
        this.partnerName = "NAF";
        break;
      default:
        this.currentPartner = BannerManagementComponent.partners.EXPLORER;
    }

    this.getInfoPartner();
  }

  mapPartnerResponseData(res) {
    this.partnerInfo = res.Data;
    this.configCKEditor = !!res.Data.content;
    this.bannerPhoto.localURL = res.Data.banner;
    this.logoPhoto.localURL = res.Data.logo;
    this.bannerArr = res.Data.bannerArr;
    this.bannerMobileArr = res.Data.bannerMobileArr;
    this.bannerPhotoMobile.localURL = res.Data.bannerMobile;
  }

  getInfoPartner() {
    this.http.get(PartnerService.partnerAPI + this.currentPartner).subscribe(
      (res: any) => {
        if (res.Data) {
          this.mapPartnerResponseData(res);
        }
      },
      (error) => {
        this.toastr.error(error.error.Message, "Error");
      }
    );
  }

  ngOnInit() {
    this.bannerPhoto = new Photo();
    this.logoPhoto = new Photo();
    this.bannerPhotoMobile = new Photo();
    this.getInfoPartner();
  }

  public fileChange(event, type) {
    this.fileList = event.target.files;

    if (this.fileList.length > 0) {
      if (
        this.uploadPhotoService.fileTypes.indexOf(this.fileList[0].type) + 1
      ) {
        this[type] = this.fileList[0];
        this.setLocalPreview(this[type], type);
      } else {
        this.toastr.error("File type not allowed", "Error");
      }
    }
  }

  public upload(f: NgForm, type) {
    if (this[type] && this[type].name) {
      if (f.valid) {
        this.formValid = true;
        this.formData = new FormData();
        this.formData.append(type, this[type], this[type].name);

        if (this.formValid) {
          this.http
            .put(
              PartnerService.partnerAPI + type + "/" + this.currentPartner,
              this.formData
            )
            .subscribe(
              (res: any) => {
                this.toastr.success("Photo uploaded successfully", "DONE");
                this.partnerInfo[type] = res.Data[type];
              },
              (error) => {
                this.toastr.error(error.error.Message, "Upload failed");
              }
            );
        } else {
          this.toastr.error("Check your input and try again.", "UPLOAD FAILED");
          this.failValidation();
        }
      } else {
        this.formValid = false;
        this.failValidation();
      }
    } else {
      this.photoSelected = false;
      this.formValid = false;
    }
  }

  public dropped(event: UploadEvent, type) {
    if (event.files) {
      const droppedFile = event.files[0];

      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;

        fileEntry.file((file: File) => {
          if (this.uploadPhotoService.fileTypes.indexOf(file.type) + 1) {
            this[type] = file;
            this.setLocalPreview(this[type], type);
          } else {
            this.toastr.error("Files not allowed", "Error");
          }
        });
      } else {
        this.toastr.error("Only one file can be dropped", "Error");
      }
    }
  }

  errorPhoto(type) {
    if (
      this[type + "Photo"].localURL &&
      this[type + "Photo"].localURL != null
    ) {
      this[type + "Photo"].localURL =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVYAAAC6CAYAAAD1XmXOAAAdIUlEQVR4Xu2dCXgUxbbHD0kQCKgQZPWhgA8CIoogEOGKiiAEfSp6BVQi8BSeGxKysS8JCYshLII7CugjEVkEAVlEguzCVQEXYsDLIoKQyCaBhIDe71SccdZMzUxNT3fPv7/vfldmqqtP/U7lN9VV1TMV+vR58k/CAQIgAAIgoIxABYhVGUtUBAIgAAKCAMSKjgACIAACiglArIqBojoQAAEQgFjRB0AABEBAMQGIVTFQVAcCIAACECv6AAiAAAgoJgCxKgaK6kAABEAAYkUfAAEQAAHFBCBWxUBRHQiAAAhArOgDIAACIKCYAMSqGCiqAwEQAAGIFX0ABEAABBQTgFgVA0V1IAACIACxog+AAAiAgGICEKtioKgOBEAABCBW9AEQAAEQUEwAYlUMFNWBAAiAAMSKPgACIAACiglArIqBojoQAAEQgFjRB0AABEBAMQGIVTFQVAcCIAACECv6AAiAAAgoJgCxKgaK6kAABEAAYkUfAAEQAAHFBCBWxUBRHQiAAAhArOgDIAACIKCYAMSqGCiqAwEQAAGIFX0ABEAABBQTgFgVA0V1IAACIACxog+AAAiAgGICEKtioKgOBEAABCBW9AEQAAEQUEwAYlUMFNWBAAiAAMSKPgACIAACiglArIqBojoQAAEQgFhN1AfGjh1LkZGRJmqR+ZvyySfLadu27eZvaIi1EGI1UcKnT59O1apVNVGLzN+U7Jwcyt2Qa/6GhlgLIVYTJRxiNV4yIVbj5UwmYohVhpJBykCsBkmUTZgQq/FyJhMxxCpDySBlIFaDJApiNV6ivIwYYvUSmJ6LQ6x6zo7r2DBiNV7OZCKGWGUoGaRMeWK9dOmSQVphvjDDwsMpIjzcZcMgVvPlm1sEsZoor+7EWlR0gRISEkzUUmM1pXPnztS7dy+I1Vhp8ytaiNUvfPo62b1Yiyg+fqi+gg2haO677z7q06c3xBpCOYdYTZRsiFWfyYRY9ZmXQEYFsQaSrsZ1Q6waA5e8HMQqCcpExSBWEyUTYtVnMiFWfeYlkFFBrIGkq3HdEKvGwCUvB7FKgjJRMYjVRMmEWNUls1KlSlSzZk2qXLkyFRcXU2FhIfm6ZQ1iVZcXo9QEsRolUxJxQqwSkMopctVVV9GdHe6kmJgYatSwIYXb7D29cuUKHTx4iHbs2EHbt2/3SrIQq395MeLZEKsRs+YmZojV92S2bNmS+vZ9iqKiojxWcurUKfrgg/+n7777zmNZLgCxSmEyVSGI1UTphFh9S2b37t3p0Ud7UoUKFaQr+PPPP2nx4iW0bt06j+dArB4Rma4AxGqilEKs3ifz7nvupr5PPeX9iX+dwSPXTZs2lXs+xOozXsOeCLEaNnXOgUOs3iWzfv36NGbMaIqIiPDuRJvSpaWlNGFCOh0/ftxtHRCrz3gNeyLEatjUQaz+pu7llwcTz636e+zZu5dmz5oNsfoL0kTnQ6wmSqZeRqzVq1enM2fO6Jps7dq1KT19glfzqu4axPOto0aNpoKCApdFMGLVdVcISHAQa0CwBqdSPYi1Ro0alJKSTJMmTaZz584FB4TEVbt27Uq9ej0uUVKuyMKFH9H69eshVjlcpi8FsZooxXoQa2wsr7A/Svn5+TRt2nTi/Z96PJ599llq376dstB27PiS3n33XYhVGVFjVwSxGjt/dtEHW6y8XSk1NZXq1asr4tqwIZdycnJ0STgpKZGio6OVxZaXl0dZWdMgVmVEjV0RxGrs/OlKrI0bN6YRI4bbxTRv3nzaunWr7ignJSVRdHRTZXHl5f1IWVlZEKsyosauCGI1dv50Jda+ffvS3Xd3souJtyNlZk6lgwcP6or0oEGDqG3bO5TFtHPnTnrnnTkQqzKixq4IYjV2/nQjVn7OPjPzFYqMjHQieurUacrIyNDVYhY/bfXYY48qyz4/hbV27VqIVRlRY1cEsRo7f7oRa9t2bWnQwIFuaebn76dp06bpZjGLHw4Ynzqe5B9idd9ReLvVuHHj3T4kgO1WJvojk2wKxCoJygjFgrl4FR8/hFq0aFEupg25uZSTrZ/FrMSkRGqmYAFr3759YgeEuwNiNcJfj9oYIVa1PINaW7DEyntXJ0+eRGFhYR7br6fFrIYNG4rFNpm43TWMt5Pxnt3Dhw9DrB6zHzoFIFYT5TpYYo2NjRXfDiVz6G0xy5vYXbVvyZKltGbNmnKbjhGrTM8wVxmI1UT5DIZYxd7VtFSqV7ds76rMoafFLI6fH2jo3r2bTOh2ZVioLFZPB8TqiZD53odYTZTTYIjV1d5VGaRiMWv6dLpy+bJM8YCXibkzhvr07k1Vq1b1eK3z54to4cIPiZ+2kjkgVhlK5ioDsZoon8EQq6u9q7JIc3NzKVtHi1ks1XvvvYfax8RQ3Tp1nJrx668nxE+zbNy4kYqKimSbiV8QkCZlnoIQq3lySVqLtby9q7JY9bSYZRszf0MXfwMWt5F/RPDkyZM+f2MXRqyyvcE85SBW8+RSc7G2a9eOBg581i+CelvM8qsxbk6GWANBVd91Qqz6zo9X0Wk9YpXZuyrTgFOnT1NGur6ezJKJW7YMxCpLyjzlIFbz5FLTEas3e1dlEPNiFn8wXNbJYpZMzLJlIFZZUuYpB7GaJ5eaitXf/Z+usOttMUtV14BYVZE0Tj0Qq3Fy5TFSraYCeO9nWloq1fVi76rH4P8qoNfFLNn4XZWDWP2hZ8xzIVZj5s1l1FqJtfFNjWnEcPvvXVWF0YyLWRCrqt5hnHogVuPkymOkWok1Lq4vdepk/72rHoPzosDp06cpPWMinTt71ouz9FsUYtVvbgIVGcQaKLJBqFcLsarYuyqDZv9+/ppBcyxmQawyGTdXGYjVRPnUQqwq9q7KIs/N3UjZ2dmyxXVbDmLVbWoCFhjEGjC02leshVhV7V2VpTNv/nzaukXtb2bxrxxERUXR0aNHZcPwqxzE6hc+Q54MsRoyba6DDrRYVe9dlUGvejGLv4N10KCyXzpITU2jkpISmTD8KgOx+oXPkCdDrIZMW3DEGoi9qzL4eTErI2MinfVjMYu3iHXu3Jn++c/HKCIiQlxWq32zEKtMls1VBmI1UT4DOWIN5N5VmRT4s5jFt/79+j1NrVu3trsU/1ZV1rRp9GPejzIh+FwGYvUZnWFPhFgNmzrnwAMp1ptuuomGDx8WVFq+LGY1bNSQBg0cRLVqXecy9oKCgoBPCUCsQe02Qbk4xBoU7IG5aCDFGui9q7JE5s9/n7Zs2eKxuKtbf3cn+SJsjwHYFIBYvaFljrIQqznyKFoRKLFqtXdVJhUyi1llt/79qHXr22WqpEBPCUCsUmkwVSGI1UTpDJRYtdy7KpOO8hazGjVqRAMHDnR76++ufjElkJZGJcXqdwlArDJZNVcZiNVE+QyUWOPj46lFi5t1RcpxMcubW3+tpwQgVl11HU2CgVg1wazNRQIh1mDsXZWllbtxI2UvyCZvb/3d1c9TAvwYbV5enmwIUuUgVilMpioEsZoonYEQa2yPWHq0Z0/dUlq9eg3d0fYOqnWd61V/bwMvmxKYQCXFxd6e6rY8xKoMpWEqglgNkyrPgaoWa7D3rnpucWBKqN4lALEGJk96rhVi1XN2vIxNtVj1sHfVSwRKiqueEoBYlaTFUJVArIZKV/nBqharXvauBiNFBQWFlJaWRsUKpgQg1mBkMLjXhFiDy1/p1VWKVU97V5VC8qIyVVMCEKsX0E1SFGI1SSK5GSrFqre9q8FIk6opAYg1GNkL7jUh1uDyV3p1lWLV495VpbAkK1MxJQCxSsI2UTGI1UTJVCVWPe9dDUa6/J0SgFiDkbXgXhNiDS5/pVdXJdYePWKpp473riqFJlGZv1MCEKsEZJMVgVhNlFAVYg3VvaueukFBYSGlpfq2SwBi9UTXfO9DrCbKqQqxhureVZluYHmEVqasbRmI1Vtixi8PsRo/h9YWqBBrXFwcdep0l4moqGuKr1MCEKu6HBilJojVKJmSiNNfsZbtXc2kyMgqElcLzSK+TAlArKHXVyBWE+XcX7Fi76pcZ/B2SgBileNqplIQq4my6a9Y44fGU4ub9fW9q3pMj7dTAhCrHrMY2Jgg1sDy1bR2f8RaI6oGTZ40icLCwjSN2agXKywsFD9CKPNdAhCrUbPse9wQq+/sdHemP2LF3lXv07lx40ZasCDb44kQq0dEpisAsZoopb6KtWzvahrVrVvHRDQC3xTZKQGINfC50NsVIFa9ZcSPeHwVK/au+g5dZkoAYvWdr1HPhFiNmjkXcfsqVuxd9a8TeJoSgFj942vEsyFWI2bNTcy+iFXsXZ2aSZFVsHfV167gaUoAYvWVrHHPg1iNmzunyH0Ra5XISLqpcWMTUQhOU86dO0dHjhxxeXGINTg5CeZVIdZg0ld8bV/EqjgEVOeCAMQaet0CYjVRziFWfSYTYtVnXgIZFcQaSLoa1w2xagxc8nIQqyQoExWDWE2UTIhVn8mEWPWZl0BGBbEGkq7GdUOsGgOXvBzEKgnKRMUgVhMlE2LVZzIhVn3mJZBRQayBpKtx3e7Eyvssf//9d42jweUsBHivcOXKlV0Cyc7JodwNuYBlMgIQq4kS6k6sJmqi6ZoCsZoupaJBEKuJ8gqxGi+ZEKvxciYTMcQqQ8kgZSBWgyTKJkyI1Xg5k4kYYpWhZJAyEKtBEgWxGi9RXkYMsXoJTM/FIVY9Z8d1bBixGi9nMhFDrDKUDFJm0qSJVLVqVYNEizCZwKLFi2nzps2AYTICEKvJEormgAAIBJ8AxBr8HCACEAABkxGAWE2WUDQHBEAg+AQg1uDnABGAAAiYjADEarKEojkgAALBJwCxBj8HiAAEQMBkBCBWkyUUzQEBEAg+AYg1+DlABCAAAiYjALGaLKFoDgiAQPAJQKzBzwEiAAEQMBkBiNVkCUVzQAAEgk8AYg1+DhABCICAyQhArCZLKJoDAiAQfAIQq4Y5qFmzprjapUuXxG9QVahQgaKioqwRWF53DMlyHr9eWlpK586dc4r62muvpYiICPH6b7/9Vm6rqlSpQk2aNKEaNWpQSUkJ/fvgv+nkiZNO59SsybFVcFsX/5bWqVOnXL7P37Jl+Z2n06dP0x9//GFXztKmCxcv0MULF+3eCwsLo4YNG1K9+vUoPCycCgsLaP/+A6LtloPbym32dFy8eJEuXLjgVCwyMpKYg7vjypUrdObMGbu3uU3Mja/L3A4fOUzHjx13mwtuM7fd9qhYsSJdc8014qWioiIqLi4WnCzfSsa5tW0nl7Pk1l2/sdTP1+PzOXYcwSUAsWrEv0JYGM2e9SrxD8vt2rWL3n77HeI/7pkzZ1gj+PXECRozeoxdRHXr1qUJE9Ksr+Xl/UhZWVl2ZbjOqVMzraJIT8+gw4cPO7WMhfXAAw9Qt273U6VKlazvsyC//fZbev/9D+js2bPW12fPnmVXzrHCi8XFNOTlIcTnOx59+vQm/nVSPj76aBF99tln1iJhYeE0+7VZVDEigpYv/4RWrlxpfa958+b01FNPUp06deyq/P338/Txx0tp8+Yt4vXGjRvTiBHDPWZv5cpVtHz5cqdyDz38EP3Pgw+6Pd82FyzxRx55mDp37kwsRtvjx/x8+uD9D+jEiRPWl1NSkoWACwoKaOTIUXblo5tFU1JioniNeW/evJk6depEcXF9xWtbt26jefPm2Z0zatRI8UGzc9cueof7TdWqNHPGdJexFxeX0O7du+njZcvolIcPWI/wUMBnAhCrz+i8O1FGrFzjhAnpdOTIEWvlPXrEUs+ePa3/diXW9u3b07PPPmMts2FDLuXk5DgFOGDAAOrQ4U7xOo+KTpw4SVdfXc068jt27DhNnDhRjMb4UCVW/mMfN26cdXTrTqy33norvfDC8xQeHi5kXVBYSJcvX6a6deoQfyjwsWTpUlqzeo1mYuW7iueff55uv72VuD6PGk+eZG5XW7nx3cekSZOFSPnwR6zc7qlZWZT/Y741f96I1XISxzTllVfoxK9/C9+7HovS/hCAWP2h58W5smJdvXoNLV261Frz6NGj6MYbbyxXrEMThtLNzZuL220W0Pnz5yk5OUVIyXK0atWKXnzxBfHPH37YR3PmzBHTEVy+e/fu1LPnI+K9RYsW07p16+zEumfPHpo3b75Ta1kCfDvr6rAdsfL7u3fvoddee00UdSVWvh3OyEgXt8kc/+uvv0H79+8X5WvXri1ir1+/vrjNTUubIEaItrfy/fr3o1a33SbEN2zY3yNZ/jf/z/GwHbFyfY637MySpxA6dOhAAwb0F6d/881uMZrk11m4//jHP6hv36cEw3379tG0aWWjSH/EyucfP/4rpaWlWfNXnli/+GITLVu2TMTA00p8lxAT017EkZ+/nzIzM73opSiqigDEqoqkh3o8iZXnAlkUPEobNXKUGLHxPCT/KgD/EbPAeB7OccQaVbMmTf6rzKpVn9IDD/QQkbzxxpv09ddfW6NKSBhKfJvNc3ojRowU8rIcXP9LL70kRmAHDhygDz/80E6sX331Fb355ltekbKIldvB9fPBsvzmm29cipUl1a/f06Lc3LnzaNu2bXbXu+GGG4g/ZLguVyPy5577P2rTpo2Q6IsvvuQxVluxsojdzRWPHj2abrzxBvEhxNwso3nLBeLi4qhTp7vEP8eOG0/Hjx3zS6yWD0fbKZLyxLp+/XpauPAju/YOHjyYbr21pXht3LjxdOzYMY88UEAtAYhVLU+3tXkS67Zt26236RMnTqKDBw9Sl65dqHevXlRYWEgFBYXUvHkzJ7E++OCD9PDDDwlhJiYm0chRI+n6+vWJR5mzZ5eNEPnWetasV8X8IIuNBSdzWKYCeL72i02bnE756cBPbv9oLWLlxRSeh2x7xx1CXvyHfulSqdMc6zPP/C/FxMSIEWl8/FDRHscjbUIa1atbl3755RcaPz7V7m1/xPrqq7Po7Lm/55a54l+O/iLmw3kOnGW+detWl6P2Zs2aUWJigohlwYJs2rhxo19iXb/+c+rS5T4xVcNt5GkHb8XaunVrev7550RMfKfBsePQlgDEqhFvT2JdkJ1NXbt0pdq1a9G6dZ/RokWLKCUlhZo0+W/6dPVqsXjBt/u2I1b+g+fb51q1atH27dvpvffmisUpXmhhQaWkDBOrxHx7nZU1VbTUUjf/Ny9gld3m/r3yX3KphOa+N1eU9TTHmpPzIW3YsMElQVux8rxxaloqRVapQjzCWrRoiZNYExMTqVmzaLESz9MYro6XXx5MLVu2FLfiQ4bEKxOrq2slJSWLxcW0tDKBL1u2nFatWuVU9LrrrhN3FXys+vRTWvbxMr/EytdlUderV09M2fAPRHor1gYNGtDYsWWLoIuXLKG1a9Zq1MtxGQsBiFWjvuBRrAuyqXr1a4UYeWTHiyFTpkwWc2epqWn0eK/HncTatGlTSk5OEi2YMWMmff/992I+kmXLh2U1vmq1qjRjetn8H4uQhcgHi2MGj8hsGFy4cJHi4+PFVIRFrBzPgQM/OZHi23W+pqvDVqw8kr733nvpySefEPPAkydPoeSUZLtdAUOHxtPNN99MvPqfkFA2AnQ8LHPJfFuekFC2sm45/Bmx8h2B4xalKVNeEVMzFpa8c4Fvzx0P3r2Qnj5BvLxixQr65JMVfok1fmiCuONISkoUI+U5c94VI1h3uwJcTQXwtMmYMaNFTAsXLiQeBePQlgDEqhFvGbHm5+dTaup4EdGOL7+kmPbtiVfqeUXdIhXbESuPNnlxhQ++Zfzjj7JtT3Xq1BZ/lEePHhVS5mP69GlUrVo1MYfK0uCDpwhuueUW8d/t2rWldu3akSux+jPHyiNmFit/QAwfPowaNWokdj1cf/314vqWuUSWLsuXhc5zmY57ccPCwykz8xW65uqr7dqgQqzu5lh5mxVPBfCUwN69e2nWrNlOvaVt27Y0aNBA8fo7c+bQzi93UnJyMjVt2kR8QNoupHGZZs2bU2LCUFF+/vz5tGXLVrvtVizWovPnqf+A/tSxQwdxx8HTIvyB6Wq7lSuxduzYkfr37yeuwTFz7Di0JQCxasRbRqw8Pzd27Fhq0OC/rFHxHkzei+koVl5F572rtvtRXTXFsn2rf//+1LFjByGuzMyp1hV3PoclzNLjvaGBEitfh0dSI0eOEEK1HBax8miVR6185ObmUna2/Xaxu+66i55+Ok68v3jxElq71v721p8Ra3mLVy+8+ALd3qqVGNGmZ2TQ0Z+PWmPndgwbliI+LHhOlKdeeFGQRcvC5XP41t52oZD3wj7xRB9Rh+Uuw3Yfq0Ws/CHI+5f5/y2HjFh5lM37e3kqgRfaeFqFF0ZxaEsAYtWIt6xYeevTY489ao1q9OgxYmuRo1htRyW8SMULOpajarVqNGrkCCHMzz/fIFb5+ZaV59149FVUdEFsmufRK08H3HPvPXRHmzbidFdi/fnoUdq+bbtLUvxh4PikEBd0nAqwnNyr1+PUtWtXJ7FyrEnJSdS0SRPx3qZNm8W8cenlUmp5S0ux24FHkKdPnxEjeEdZBEqsvNWNRcUS5dEjb206dOiwmLfu1q2bWFDkY83atbRk8RLx37ZbtHjL2IoVK8WuAh6l9+7dS+yB5fiTU4ZRSXGxyxEr12ObY/63K7Hylip+IIAP3pPMQud5Xz54lwjHi0N7AhCrRsxlxWq7xerQ4cOUkZ4hInQU6997JQtp1Kiy7Vm2h+V9/oPmkRTvaeXVYn6QwPHpIT7v5MkCioqqIVbsHedYy0NkGWE5lnEnVh5p83SH5VFe221F1atXJ94WxqMtVweP/GbOfJUOHTrk9HagxCpE2bEDPR0XZzfStg1g95499Nabb1n3nbKEefQdHR3tsh2cK54G4Kes+HA1YuXXxYdNUiLxXLo7sbrLzZdf7qS5c+fi8VaN/r4dLwOxagSe/0iGDBlCFStGUF5enhjFVKpcmV4eXLbn8rPP1ltHHryfk+fUeJsMb8Pig0d6PHo6cuRn8QgoPw3E20P/9dVXlLsh16kVPF96992dxOu86d8iI5ZWbI9YuqVFC7EvtqTkEu3du4cWLV5CPR95WIzEXuW5xD//pPh4jtf+EU7HC/Fo2dWtJt/ytmnTWoyOX3/9dbvTeGW/e/du4jWeY+SRqeXgqY0uXbpQ+/btBAPmxjsF+AGD1atXOz2/bznvoYceoujoplRaeplmzPj7MWF36eXRoOUptLfeetvl9y/YntvghgYU2z1W7AWOjKwihPXzz0dp06ZNYs+t4wcbc7O0g+8WeI65uKSEfjpwQIxubZ+suu222+j++8tG8Y48OV/8EAIfln7DH06D/+o3tjHyHDt/r8KuXf+iH374QaOejcu4IgCxhnC/4D9+Hsm6etZfD1h45MditX2CTA9xVax4FV25ctnpi2XcxcZSDQ+PoNJS5yfA9NAexKCeAMSqnilqBAEQCHECEGuIdwA0HwRAQD0BiFU9U9QIAiAQ4gQg1hDvAGg+CICAegIQq3qmqBEEQCDECUCsId4B0HwQAAH1BCBW9UxRIwiAQIgTgFhDvAOg+SAAAuoJQKzqmaJGEACBECcAsYZ4B0DzQQAE1BOAWNUzRY0gAAIhTgBiDfEOgOaDAAioJwCxqmeKGkEABEKcAMQa4h0AzQcBEFBPAGJVzxQ1ggAIhDgBiDXEOwCaDwIgoJ4AxKqeKWoEARAIcQIQa4h3ADQfBEBAPQGIVT1T1AgCIBDiBCDWEO8AaD4IgIB6AhCreqaoEQRAIMQJQKwh3gHQfBAAAfUEIFb1TFEjCIBAiBOAWEO8A6D5IAAC6glArOqZokYQAIEQJwCxhngHQPNBAATUE4BY1TNFjSAAAiFOAGIN8Q6A5oMACKgnALGqZ4oaQQAEQpwAxBriHQDNBwEQUE8AYlXPFDWCAAiEOAGINcQ7AJoPAiCgngDEqp4pagQBEAhxAhBriHcANB8EQEA9gf8AoXSFJnPkpWkAAAAASUVORK5CYII=";
    }
  }

  preventDefault(event, prevent) {
    if (prevent) {
      event.preventDefault();
    } else {
      return;
    }
  }

  public setLocalPreview(file: File, type) {
    this.photoSelected = true;

    if (file.size < 20000000) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this[type + "Photo"].localURL = reader.result;
      };
    } else {
      this.toastr.error("Max file size exceeds 20MB", "Error");
    }
  }

  public fileOver(event, type) {}

  public fileLeave(event, type) {}

  selectCategory(category) {
    this.bannerPhoto.category = category;
  }

  selectPartner(partner) {
    this.bannerPhoto.partner = partner;
  }

  failValidation() {
    setTimeout(() => {
      const offset_top =
        $(".text-danger:first").offset().top -
        $("main").offset().top +
        $("main").scrollTop() -
        50;
      $("html, body").animate({ scrollTop: offset_top }, "slow");
    }, 0);
  }

  public onAdding(tag: string): Observable<any> {
    return of(tag.toLocaleLowerCase());
  }

  public updatePartnerInfo() {
    // Get newest content
    if (this.partnerInfo.content && this.configCKEditor) {
      this.partnerInfo.welcome = this.partnerInfo.slogan = "";
    }

    if (
      (this.partnerInfo.welcome || this.partnerInfo.slogan) &&
      !this.configCKEditor
    ) {
      this.partnerInfo.content = "";
    }

    this.http
      .put(PartnerService.partnerAPI + this.currentPartner, this.partnerInfo)
      .subscribe(
        (res: any) => {
          this.toastr.success(
            "Update partner information successfully",
            "DONE"
          );
          if (res.Data && res.Data) {
            this.partnerInfo.banner = res.Data.banner;
            this.partnerInfo.logo = res.Data.logo;
            this.partnerInfo.title = res.Data.title;
            this.partnerInfo.slogan = res.Data.slogan;
            this.partnerInfo.welcome = res.Data.welcome;
            this.bannerPhoto.localURL = res.Data.banner;
            this.logoPhoto.localURL = res.Data.logo;
            this.bannerPhotoMobile.localURL = res.Data.bannerMobile;
            this.partnerInfo.bannerNavigateUrl = res.Data.bannerNavigateUrl;
            this.partnerInfo.iconPartnerUrl = res.Data.iconPartnerUrl;
            this.partnerInfo.content = res.Data.content;
            this.partnerInfo.bannerArr = res.Data.bannerArr;
            this.partnerInfo.bannerMobileArr = res.Data.bannerMobileArr;
            this.eventService.publish("refreshPartnerInfo");
          }
        },
        (error) => {
          this.toastr.error(error.error.Message, "Update failed");
        }
      );
  }

  public get croppieOptions(): CroppieOptions {
    const opts: CroppieOptions = {};

    opts.viewport = {
      width: $(window).width(),
      height: 250,
      type: "square",
    };

    opts.boundary = {
      width: $(window).width(),
      height: 250,
    };

    opts.enforceBoundary = true;
    opts.showZoomer = false;
    opts.enableZoom = true;
    opts.mouseWheelZoom = false;

    return opts;
  }

  public get croppieMobileOptions(): CroppieOptions {
    const opts: CroppieOptions = {};

    opts.viewport = {
      width: $("#coverBannerMobile").width(),
      height: $("#coverBannerMobile").height(),
      type: "square",
    };

    opts.boundary = {
      width: $("#coverBannerMobile").width(),
      height: $("#coverBannerMobile").height(),
    };

    opts.enforceBoundary = true;
    opts.showZoomer = false;
    opts.enableZoom = true;
    opts.mouseWheelZoom = false;

    return opts;
  }

  public uploadBanner(type, showToast = true) {
    this.formData = new FormData();
    this.coverImage_file = new File(
      [this[type + "FileCropped"]],
      this.coverImage_file.name,
      { type: "image/jpeg" }
    );
    this.formData.append(type, this.coverImage_file, this.coverImage_file.name);

    if (this.formData) {
      let _type = type == "bannerMobile" ? "banner-mobile" : type;

      this.http
        .put(
          PartnerService.partnerAPI + _type + "/" + this.currentPartner,
          this.formData
        )
        .subscribe(
          (res: any) => {
            if (showToast) {
              this.toastr.success("Photo uploaded successfully", "DONE");
            }
            this.partnerInfo[type] = res.Data[type];
            this[type + "FileCropped"] = null;
            this[type + "EditStatus"] = false;
            this.bannerPhoto.localURL = res.Data.banner;
            this.bannerPhotoMobile.localURL = res.Data.bannerMobile;
            this.eventService.publish("refreshPartnerInfo");
          },
          (error) => {
            this.toastr.error(error.error.Message, "Upload failed");
          }
        );
    } else {
      this.toastr.error("Check your input and try again.", "UPLOAD FAILED");
      this.failValidation();
    }
  }
}
